import env from '../../../../config/environment'

angular
    .module('eficienciaFiscalModule')
    .service('httpService', ['$http', '$timeout', '$compile', '$q', 'tempService', 'pathService', 'RateLimitingService', 'EfLockScreenService', '$injector', function ($http, $timeout, $compile, $q, tempService, pathService, rateLimiting, EfLockScreenService, $injector) {

        var requests, timeoutId, autoLogOffDisabled,
            service = this;

        service.rateLimitPendingResolvers = []
        service.isRateLimitModalOpen = false

        service.disableAutoLogOff = function () {
            autoLogOffDisabled = true
        };

        service.post = function (url, data, opts) {
            opts = angular.extend({
                method: 'POST',
                url: url,
                data: data
            }, opts || {});

            return service.request(opts)
        };

        service.put = function (url, data, opts) {
            opts = angular.extend({
                method: 'PUT',
                url: url,
                data: data
            }, opts || {});

            return service.request(opts)
        };

        service.get = function (url, params, opts) {
            opts = angular.extend({
                method: 'GET',
                url: pathService.parametrize(url, params || {})
            }, opts || {});

            return service.request(opts)
        };

        service.request = function (options) {
            var UsuariosService = $injector.get('UsuariosService')

            if (timeoutId)
                clearTimeout(timeoutId);

            if (!autoLogOffDisabled) {
                timeoutId = setTimeout(function () {
                    service.request({
                        method: 'POST',
                        url: env.api_url + '/base/acesso',
                        noRetry: true
                    })
                }, 900000);
            }

            var _bkpOptions = {};

            angular.forEach(options, function (value, key) {
                _bkpOptions[key] = value;
            });

            var deferred = $q.defer();

            options = {
                method: options.method,
                url: options.url,
                data: options.data || undefined,
                params: options.params || undefined,
                onPreExecute: options.onPreExecute || undefined,
                onSuccess: options.onSuccess || undefined,
                onError: options.onError || undefined,
                onPostExecute: options.onPostExecute || undefined,
                clickEvent: options.clickEvent || undefined,
                element: options.element || undefined,
                loadingText: options.loadingText || "",
                loadingTop: options.loadingTop || false,
                blockAfter: options.blockAfter || false,
                blockScreenExt: options.blockScreenExt || false,
                blockScreen: options.blockScreen || false,
                screenId: options.screenId || "body",
                timeout: options.timeout || deferred.promise
            };

            if (options.clickEvent != undefined)
                options.element = $(options.clickEvent.currentTarget);

            if (options.loadingTop)
                $('#loading-top').css({ top: 0 }).find('span').html(options.loadingText);

            if (options.element != undefined) {
                if (!options.loadingTop) {
                    var oldHtml = options.element.html();
                    options.element.html("<i class='fa fa-circle-o-notch fa-spin'></i> " + options.loadingText);
                }
                options.element.attr('disabled', true);
            }

            if (options.onPreExecute != undefined)
                options.onPreExecute();

            if (options.blockScreen == true) {
                options.div = "<div style='position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 8' id='blockScreen'></div>";
                $(options.screenId).append(options.div);
            }

            if (options.blockScreenExt == true) {
                var blockScreenExtId = 'blockScreenExt' + options.screenId.replace(/[^\w]/g, '_');
                appendBlockScreenExt(options.screenId, blockScreenExtId);
                blockScreenExtId = "#" + blockScreenExtId;
            }

            if (options.params) {
                options.url = pathService.parametrize(options.url, options.params)
                options.responseType = options.params.responseType
            }

            var promise = $http({
                method: options.method,
                url: options.url,
                data: options.data,
                responseType: options.responseType,
                timeout: options.timeout,
                headers: cbk.getHeaders()
            })
                .then(function (resp) {
                    if (options.loadingTop)
                        $('#loading-top').css({ top: '-12%' });

                    if ((options.element != undefined) && !options.blockAfter) {
                        if (!options.loadingTop)
                            options.element.html(oldHtml);

                        options.element.attr('disabled', false);
                    }

                    if (options.onSuccess != undefined)
                        options.onSuccess(resp.data);

                    if (options.onPostExecute != undefined)
                        options.onPostExecute();

                    if (options.blockScreen == true)
                        $('#blockScreen').remove();

                    if (options.blockScreenExt == true) {
                        $(blockScreenExtId).remove();
                    }

                    return resp
                }, function (resp) {
                    var data = resp.data, status = resp.status, headers = resp.headers, config = resp.config

                    if (options.loadingTop)
                        $('#loading-top').css({ top: '-12%' });

                    if (options.element != undefined) {
                        if (!options.loadingTop)
                            options.element.html(oldHtml);

                        options.element.attr('disabled', false);
                    }

                    if (options.onError != undefined)
                        options.onError(data, status, headers, config);

                    if (status == 403 && UsuariosService.usuarioLogado) {
                        return EfLockScreenService
                            .show(UsuariosService.usuarioLogado)
                            .then(function () {
                                if (!_bkpOptions.noRetry) return service.request(_bkpOptions);
                            })
                    }

                    if (status == 429) {
                        return rateLimiting.wait(function () {
                            return service.request(_bkpOptions);
                        }, headers('ttl'));
                    }

                    if (status == 401)
                        $.smallBox({
                            title: "Você não tem permissão para esta ação.",
                            content: "Tentativa gravada em log.",
                            color: "#A65858",
                            timeout: 5000,
                            icon: "fa fa-exclamation"
                        });

                    if (status == 442)
                        Confirm.warning('Novo acesso identificado', 'Um acesso a este usuário foi identificado em outro computador e por isso a sessão ' +
                            'atual será invalidada. Caso não reconheça o outro acesso recomendamos a troca de senha o mais brevemente possível.', {
                            'Ok': function () {
                                window.location.href = '/logout'
                            }
                        });

                    if (status == 500) {
                        var mensagem = "Aguarde alguns minutos e tente novamente.";
                        if (data.message == 'remocao_itens_vinculados')
                            mensagem = "Existem itens vinculados ao registro e sua remoção não será possível até que os mesmos sejam removidos ou desvinculados.";

                        $.smallBox({
                            title: "Algo deu errado...",
                            content: mensagem,
                            color: "#A65858",
                            timeout: 15000,
                            icon: "fa fa-frown-o"
                        });
                    }

                    if (options.onPostExecute != undefined)
                        options.onPostExecute();

                    if (options.blockScreen == true)
                        $('#blockScreen').remove();

                    if (options.blockScreenExt == true)
                        $(blockScreenExtId).remove();

                    throw resp
                });

            promise.abort = function () {
                if (options.blockScreen == true)
                    $('#blockScreen').remove();

                if (options.blockScreenExt == true)
                    $(blockScreenExtId).remove();

                deferred.resolve();
            };

            promise.finally(
                function () {
                    promise.abort = angular.noop;
                    deferred = promise = null;
                }
            );

            return promise;
        };

        this.loadContent = function (scope, divLoader, url, options) {
            options = options || {};

            options = {
                onPreExecute: options.onPreExecute || undefined,
                onPostExecute: options.onPostExecute || undefined,
                clickEvent: options.clickEvent || undefined,
                loadingText: options.loadingText || "",
                loadingTop: options.loadingTop || false,
                blockScreenExt: options.blockScreenExt || false,
                blockScreen: options.blockScreen || false,
                compileAfter: (options.compileAfter == undefined) ? true : options.compileAfter
            };

            if (options.onPreExecute != undefined)
                options.onPreExecute();

            if (options.clickEvent != undefined)
                options.element = $(options.clickEvent.currentTarget);

            if (options.loadingTop)
                $('#loading-top').css({ top: '0%' }).find('span').html(options.loadingText);

            if (options.element != undefined) {
                if (!options.loadingTop) {
                    var oldHtml = options.element.html();
                    options.element.html("<i class='fa fa-circle-o-notch fa-spin'></i> " + options.loadingText)
                }
                options.element.attr('disabled', true);
            }

            if (options.blockScreen == true) {
                options.div = "<div style='position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 9' id='blockScreen'></div>";
                $('body').append(options.div);
            }

            if (options.blockScreenExt == true) {
                appendBlockScreenExt(options.screenId);
            }

            $(divLoader).load(url, function () {

                if (options.loadingTop)
                    $('#loading-top').css({ top: '-12%' });

                if (options.element != undefined) {
                    if (!options.loadingTop)
                        options.element.html(oldHtml);

                    options.element.attr('disabled', false);
                }

                if (options.onPostExecute != undefined)
                    $timeout(function () {
                        options.onPostExecute();
                    });

                if (options.compileAfter)
                    $(divLoader).html($compile($(divLoader).html())(scope));

                if (options.blockScreen == true)
                    $('#blockScreen').remove();

                if (options.blockScreenExt == true)
                    $('#blockScreenExt').remove();
            });
        };

        var appendBlockScreenExt = function (elm, id) {
            var html = '<div id="' + id + '" class="blockScreenExt">' +
                '<div class="center">' +
                '   <div class="circle-2x"></div>' +
                '   <div class="circle-3x"></div>' +
                '</div></div>';

            $(html).appendTo($(elm));
        }

    }]);
